import { BookOpen, Upload, Library } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface UserTypeStepProps {
  onSelect: (userType: 'learner' | 'translator' | 'reader') => void;
  onBack: (() => void) | null;
  selectedType: 'learner' | 'translator' | 'reader' | null;
}

export function UserTypeStep({ onSelect, selectedType }: UserTypeStepProps) {
  const { t } = useTranslation('common');
  
  const options = [
    {
      type: 'learner' as const,
      icon: BookOpen,
      title: t('onboarding.userType.learner.title'),
      description: t('onboarding.userType.learner.description'),
    },
    {
      type: 'translator' as const,
      icon: Upload,
      title: t('onboarding.userType.translator.title'),
      description: t('onboarding.userType.translator.description'),
    },
    {
      type: 'reader' as const,
      icon: Library,
      title: t('onboarding.userType.reader.title'),
      description: t('onboarding.userType.reader.description'),
    },
  ];

  return (
    <div className="user-type-step">
      <div className="step-header mb-8 text-center">
        <h3 className="text-2xl font-semibold text-gray-900">
          {t('onboarding.userType.title')}
        </h3>
      </div>

      <div className="options-grid grid gap-4">
        {options.map(option => {
          const Icon = option.icon;
          const isSelected = selectedType === option.type;

          return (
            <button
              key={option.type}
              onClick={() => onSelect(option.type)}
              className={`option-card group flex items-start gap-4 rounded-lg border-2 p-4 text-left transition-all ${
                isSelected
                  ? 'border-primary bg-primary/5'
                  : 'border-gray-200 hover:border-primary/50 hover:bg-gray-50'
              }`}
            >
              <div
                className={`icon-wrapper flex-shrink-0 rounded-full p-3 transition-colors ${
                  isSelected
                    ? 'bg-primary text-white'
                    : 'bg-gray-100 text-gray-600 group-hover:bg-primary/10 group-hover:text-primary'
                }`}
              >
                <Icon className="h-6 w-6" />
              </div>
              <div className="text-content flex-1">
                <h4 className="text-base font-semibold text-gray-900 mb-1">
                  {option.title}
                </h4>
                <p className="text-sm text-gray-600">
                  {option.description}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

